import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import appInfo from "./app-info";
import VueEvents from "vue-events";
import Vuetify from "vuetify";
import VueLayers from "vuelayers";
import VueMq from "vue-mq";
import "vuelayers/dist/vuelayers.css"; // needs css-loader

import "vuetify/dist/vuetify.min.css";
import "font-awesome/css/font-awesome.css";
import VueSocketIO from 'vue-socket.io'

import { baseStrapiUrl, baseWebUrl } from "./assets/linkTree";
import VueRecord from '@codekraft-studio/vue-record'

Vue.use(VueRecord)
Vue.use(VueEvents);
Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://apicastropol.upintelligence.es/',
  // connection: 'http://localhost:3004',
  vuex: {
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
  }
}))
Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;
Vue.use(Vuetify);
Vue.use(VueLayers);
const opts = {};
Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 1135,
    desktop: Infinity,
  },
});
export default new Vuetify(opts);
new Vue({
  router,
  vuetify: new Vuetify(),
  render: (h) => h(App),
}).$mount("#app");

Vue.prototype.$baseStrapiUrl = baseStrapiUrl;
Vue.prototype.$baseWebUrl = baseWebUrl;
